import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { statusFilterMethod } from '../../../components/Purchasing/Voucher/TableComponents/StatusFilter'
import StatusFilter from '../../../components/Sales/Orders/TableComponents/StatusFilter'
import { Link } from 'react-router-dom'
import FileCell from '../../../elements/Table/Cells/FileCell'
import IssuedStatusCell from '../../../elements/Table/Cells/IssuedStatusCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

const remittancesColumns = [
  {
    Header: 'Code',
    accessor: 'code',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/remittance/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Date', accessor: 'date', Cell: DateCell },
  { Header: 'Payee Name', accessor: 'to.payee.fn' },
  {
    Header: 'Payee Bank ',
    accessor: 'to.bank.accname',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Payor (Company)',
    accessor: 'from.payor.fn',
    hideDefault: true,
    hideable: true,
  },

  {
    Header: 'Bank ',
    accessor: 'from.bank.accname',
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Currency', accessor: 'from.currency' },
  { Header: 'Amount', accessor: 'from.amount', Cell: MoneyCell },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: StatusCell,
    filterMethod: statusFilterMethod,
    Filter: StatusFilter,
  },
  {
    Header: 'Issuance Status',
    accessor: 'issuance.issued',
    Cell: IssuedStatusCell,
  },
  { Header: 'File', accessor: 'file', Cell: FileCell },
]

function List(props) {
  const { list, fetch, fetching, company, onChangeCompany } = props

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={remittancesColumns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      show={{
        csv: {
          fileName: 'Remittance',
        },
      }}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
